webpackJsonp([263791100135453],{

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _glamorous = __webpack_require__(13);
	
	var _glamorous2 = _interopRequireDefault(_glamorous);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: '' + className },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'JASON TAYLOR'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'INTERIORS'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyPluginPageTransitions = __webpack_require__(22);
	
	var _gatsbyPluginPageTransitions2 = _interopRequireDefault(_gatsbyPluginPageTransitions);
	
	var _Logo = __webpack_require__(140);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _JTHeader = __webpack_require__(83);
	
	var _JTHeader2 = _interopRequireDefault(_JTHeader);
	
	var _subNav = __webpack_require__(29);
	
	var _subNav2 = _interopRequireDefault(_subNav);
	
	var _Carousel = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _gatsbyPluginPageTransitions2.default,
	    {
	      defaultStyle: {
	        transition: '750ms',
	        minHeight: 'calc(100vh - 50px)',
	        transform: 'translateX(100%)'
	      },
	      transitionStyles: {
	        entering: { transform: 'translateX(100%)' },
	        entered: { transform: 'none' }
	      },
	      transitionTime: 750
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'Container Container__about' },
	      _react2.default.createElement(_subNav2.default, { navLinks: ['Home', 'Contact', 'Projects', 'News'] }),
	      _react2.default.createElement('div', { className: 'About__Img__Container ' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'About__Content ' },
	        _react2.default.createElement(
	          'div',
	          { className: 'About__Logo__Container' },
	          _react2.default.createElement(_Logo2.default, { className: 'About__Logo' }),
	          _react2.default.createElement('div', { className: 'Border__Bottom' })
	        ),
	        _react2.default.createElement(_JTHeader2.default, { className: 'Name' }),
	        _react2.default.createElement(
	          'p',
	          { className: 'Text' },
	          'J.T. is known for his innovation and ability to create solutions. His designs, though rooted in tradition, mean nothing without a meaningful and emotional connection to his clients.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'Text' },
	          'His unique process fosters a relationship between client and designer which produces awe inspiring results. His background in construction opens pathways of communication often missed, bringing to life previously unrealized visions. A "playful spirit", J.T. prides himself on cultivating relationships with unique and one-of-a-kind artisans from around the world. Combine that with his adventurous nature and you can\'t help but create spaces of warmth, joy and honesty.'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-2abf77c39ea9a70843ff.js